import { useEffect, useState } from 'react';
import { MsalAuthenticationTemplate } from '@azure/msal-react';
import { InteractionType } from '@azure/msal-browser';

import { ListView } from '../components/ListView';
import { loginRequest, protectedResources } from "../authConfig";
import useFetch from '../hooks/useFetch';

import Spinner2 from '../components/Spinner2'; // Import the Spinner component


import MUIDataTable from "mui-datatables";


const columns = ["CustomerID", "CompanyName", "ContactName", "ContactTitle", "City", "Country"];

const options = {
    filterType: 'checkbox',
  };

  const CustomerListContent = () => {
    const { error, execute } = useFetch({
        scopes: protectedResources.apiCustomerList.scopes.read,
    });

    const [customerListData, setCustomerListData] = useState(null);
    const [loading, setLoading] = useState(true); // Loading state

    useEffect(() => {
        if (!customerListData) {
            setLoading(true);
            execute("GET", protectedResources.apiCustomerList.endpoint).then((response) => {
                console.log("API Response: " + response);
                setCustomerListData(response);
                setLoading(false);
            }).catch((error) => {
                console.log("API Error: " + error);
            });
        }
    }, [execute, customerListData])

    if (error) {
        return (
            <div className="container d-flex justify-content-center align-items-center" style={{ minHeight: '40vh' }}>
                <div className="alert alert-danger text-center" role="alert">
                    <h4 className="alert-heading">Oops! Something went wrong.</h4>
                    <p>Error: {error.message}</p>
                    <hr />
                    <p className="mb-0">Please try again later or contact support if the problem persists.</p>
                </div>
            </div>
        );
    }

    const XprocessCustomerListData = (customerListData = [])  => {
        return (
            <div>
                <h1>Customer List</h1>
                <ul>
                    {customerListData.map(customer => (
                        <li key={customer.CustomerID}>
                            <h2>{customer.CompanyName}</h2>
                            <p>Contact: {customer.ContactName}</p>
                            <p>Title: {customer.ContactTitle}</p>
                            <p>City: {customer.City}</p>
                            <p>Country: {customer.PostalCode}</p>
                   </li>
                    ))}
                </ul>
            </div>
        );    
    }    
    const processCustomerListData = (customerListData = [])  => {
        return (
            <div>
                <MUIDataTable
                    title={"Employee List"}
                    data={customerListData}
                    columns={columns}
                    options={options}
                /> 
            </div>
        );    
    }    

    // Render spinner if loading, else render the list
    return (
        <>
            {loading ? (
                <Spinner2 marginTop="20vh" /> // Use the Spinner component
            ) : (
                 processCustomerListData(customerListData)
            )}
        </>
    );

    // return <>{todoListData ? <ListView todoListData={todoListData} /> : null}</>;


};

export const CustomerListMui = () => {
    const authRequest = {
        ...loginRequest,
    };


    // Ensure Authentication required and the user is Logged-In
    return (
        <MsalAuthenticationTemplate 
            interactionType={InteractionType.Redirect} 
            authenticationRequest={authRequest}
        >
            <CustomerListContent />
        </MsalAuthenticationTemplate>
    );

    // Authentication NOT required
    // return (
    //     <CustomerListContent />
    // );
   
};